// The environments board, in the Deliver group: what runs where, promotion, rollback, history.
import { LayersIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";
import { routes } from "../context";

registerNav({
  id: "environments",
  group: "deliver",
  labelKey: "environments.nav",
  icon: LayersIcon,
  to: ({ params }) => (params.workspace ? routes.environments(params.workspace) : null),
  order: 10,
});
